import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getPlatforms = createAsyncThunk(
  'platforms',
  async (_, { getState }) => {
    const statePlatforms = getState().paymentOptions.platforms.platformList;

    if (statePlatforms.length) return { details: statePlatforms };

    const url = `${URL}/platforms`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    response.data.details.sort((a, b) => a.id - b.id);

    return response.data;
  },
);

export const getPlatformDetails = createAsyncThunk(
  'platforms/{platformId}',
  async (platformId) => {
    const url = `${URL}/platforms/${platformId}`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const updatePlatform = createAsyncThunk(
  'platforms/{platformId}/update',
  async (payload) => {
    const url = `${URL}/platforms/${payload.id}`;
    const response = await apiConfig.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const addNewPlatform = createAsyncThunk(
  'platforms/{platformId}/addNew',
  async (payload) => {
    const url = `${URL}/platforms`;
    const response = await apiConfig.post(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const paymentOptionsPlatformsSlice = createSlice({
  name: 'paymentOptionsPlatforms',
  initialState: {
    platformList: [],
    selectedPlatform: {},
  },
  reducers: {
    resetPlatforms(state) {
      state.platformList = [];
    },
    resetSelectedPlatform(state) {
      state.selectedPlatform = {};
    },
  },
  extraReducers: {
    [getPlatforms.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.details) {
        state.platformList = [];
        return;
      }

      state.platformList = action.payload.details;
    },
    [getPlatformDetails.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.id) {
        state.selectedPlatform = {};
        return;
      }

      state.selectedPlatform = action.payload;
    },
  },
});

export const paymentOptionsPlatformsActions =
  paymentOptionsPlatformsSlice.actions;

export const selectPlatforms = (state) =>
  state.paymentOptions.platforms.platformList;

export const selectSelectedPlatform = (state) =>
  state.paymentOptions.platforms.selectedPlatform;

export const selectPlatformsWithChannelHash = (merchantDetails) =>
  createSelector(selectPlatforms, (platforms) => {
    return platforms.filter((platform) =>
      merchantDetails.find((merchant) => merchant.platformId === platform.id),
    );
  });

export default paymentOptionsPlatformsSlice.reducer;
